// tornar-recorrente-modal.component.ts
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import type {
  ItemTornarRecorrenteCru,
  ModoTornarRecorrenteModal,
  TornarRecorrenteModalData,
} from '../models/compra-recorrente.model';

/**
 * Reexportados por compatibilidade — antes da T-271 estes tipos eram
 * declarados aqui; moraram para `compra-recorrente.model.ts` junto com a
 * extração do formulário (`TornarRecorrenteFormComponent`), mas
 * `favorites.component.ts`/`listas-favoritos.component.ts` importam
 * `ItemTornarRecorrenteCru` deste caminho — reexportar evita tocar nesses
 * dois arquivos (fora de escopo da T-271). `export type` (não `export`
 * simples) porque o builder é esbuild (`application` builder do Angular
 * 18), que transpila arquivo a arquivo e exige a anotação explícita para
 * reexportar algo que só existe em tempo de tipo.
 */
export type { ItemTornarRecorrenteCru, ModoTornarRecorrenteModal, TornarRecorrenteModalData };

/**
 * Shell fino do modal "Tornar compra de rotina" (E-44/T-260, reduzido a
 * chrome em T-271). Resolve o `modo` (parametrizado/cru) a partir do que
 * veio via `MAT_DIALOG_DATA` e hospeda o formulário de fato
 * (`TornarRecorrenteFormComponent`, extraído em T-271 — a lógica reativa
 * inteira morava aqui até então) dentro do chrome padrão de `MatDialog`
 * (`mat-dialog-title`/`mat-dialog-content`).
 *
 * Continua sendo o que `favorites.component.ts`/`listas-favoritos.component.ts`
 * (`tornarListaRecorrente()`) e a tela de gestão
 * (`compras-recorrentes.component`) abrem via `dialog.open(...)` — esse
 * mecanismo **não muda**, só ganhou o filho novo por dentro. O stepper de
 * `adiciona-negociacao-composta` (origem `bulk-list-import`) deixou de abrir
 * este shell: hospeda `app-tornar-recorrente-form` direto num 4º `mat-step`,
 * eliminando o diálogo aninhado que motivou a extração (T-270/T-271).
 */
@Component({
  selector: 'app-tornar-recorrente-modal',
  templateUrl: './tornar-recorrente-modal.component.html',
  styleUrls: ['./tornar-recorrente-modal.component.css'],
})
export class TornarRecorrenteModalComponent implements OnInit {
  /** Resolvido uma vez em `ngOnInit`, a partir do dado de abertura — mesma
   * regra de antes da extração: editando é sempre "cru" (a compra existente
   * já tem os campos completos por item, não há nada "congelado" para
   * revisar); a origem "lista-favoritos" também força "cru" (nada
   * parametrizado vem de lá). */
  public modo: ModoTornarRecorrenteModal;
  /** Trava o botão de fechar (X) do header enquanto o formulário está
   * salvando — espelhado do filho via `(salvandoChange)`, já que o estado
   * de "salvando" agora mora em `TornarRecorrenteFormComponent`. */
  public salvando = false;

  constructor(
    public dialogRef: MatDialogRef<TornarRecorrenteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TornarRecorrenteModalData,
  ) { }

  ngOnInit(): void {
    this.modo = this.ehEdicao || this.data?.origem?.tipo === 'lista-favoritos' ? 'cru' : 'parametrizado';
  }

  get ehEdicao(): boolean {
    return !!this.data?.compraExistente;
  }
}
